'use strict';

angular.module('aveoUtility').directive('aveoSecretKnock', ['$timeout', function($timeout) {
    return {
        restrict: 'A',
        scope: {
            aveoSecretKnock: '=',
            knockActivationCount: '=',
            knockNearActivation: '=',
            knockRemainingCount: '=',
            knockTimeout: '=',
            knockToggles: '='
        },
        link: function(scope, element, attrs) {
            // Configuration for "secret knock" to toggle a property (and
            // repeat the knock to toggle it back) or call a getter/setter
            // style function for a boolean value.  The knock is a click
            // event on the element with the aveoSecretKnock directive.  The
            // activationProperty becomes true when the knockActivationCount
            // is reached.  The knockRemainingProperty indicates the number
            // of knocks remaining until the knockActivationCount.  The
            // knockTimeout configures a timer in milliseconds that 
            // clears the current knock count if it expires
            // before the knockActivationCount is reached.
            // The toggling behavior can also be disabled by setting the
            // knockToggles property to false, in which case the property is
            // always set to true or the getter/setter is always called with
            // the value true.  Useful for always triggering an action based
            // on the knock.
            //
            // Usage:
            //
            // <div aveoSecretKnock="activationPropertyOrGetterSetter" 
            //      knockActivationCount="10" 
            //      knockRemainingCount="knockRemainingProperty"
            //      knockTimeout="5000"
            //      knockToggles="false">
            // </div>
            //
            var knockCounter = 0;
            var knockTimer = null;
            if (!angular.isDefined(scope.knockActivationCount)) {
                scope.knockActivationCount = 10;
            }
            if (!angular.isDefined(scope.knockTimeout)) {
                scope.knockTimeout = 5000;
            }
            if (!angular.isDefined(scope.knockToggles)) {
                scope.knockToggles = true;
            }

            element.on('click', countKnock);

            scope.$on('$destroy', function() {
                element.off('click', countKnock);
            });

            function countKnock() {
                if (!knockTimer) {
                    knockCounter = 0;
                    knockTimer = $timeout(onKnockTimeout, scope.knockTimeout);
                }
                knockCounter = knockCounter + 1;
                updateKnockRemaining();
                if (knockCounter >= scope.knockActivationCount) {
                    $timeout.cancel(knockTimer);
                    if (typeof scope.aveoSecretKnock === 'function') {
                        if (scope.knockToggles) {
                            scope.aveoSecretKnock.call(
                                scope, 
                                !scope.aveoSecretKnock.call(scope));                            
                        }
                        else {
                            scope.aveoSecretKnock.call(scope, true);
                        }
                    }
                    else if (scope.knockToggles) {
                        scope.aveoSecretKnock = !scope.aveoSecretKnock;                        
                    }
                    else {
                        scope.aveoSecretKnock = true;
                    }
                    resetKnock();
                    updateKnockRemaining();
                }
            }

            function resetKnock() {
                knockCounter = 0;
                knockTimer = null;
            }

            function updateKnockRemaining() {
                scope.knockRemainingCount = scope.knockActivationCount - knockCounter;
            }

            function onKnockTimeout() {
                resetKnock();
                updateKnockRemaining();
            }
        }
    };
}]);
